// extracted by mini-css-extract-plugin
module.exports = {"pagination":"az_wU","prev":"az_xU","next":"az_yU","liStyle":"az_zU","listStyle":"az_AU"};